import * as React from 'react';
import Card from '@mui/material/Card';

import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import Chip from '@mui/material/Chip';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import './schoolhover.scss'
export default function SchoolHoverCard({id}) {
  return (
    <Card
    sx={{
      maxWidth: 350
    }}
    >
      <CardContent>
        {/* <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          Word of the Day
        </Typography> */}
        <Typography variant="h5" component="p" sx={{fontFamily: 'mono', opacity: 0.7}}>
        PS Girls HS, Birmaharajpur
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
        Raypur, Nabrangpur
        </Typography>
        <Typography variant="body2" sx={{display: 'flex', flexWrap: 'wrap', marginTop: '1em', gap: 1}}>
        <Chip icon={<AccountCircleOutlinedIcon/>} label="Supriya Nayak" />
        <Chip icon={<CallOutlinedIcon />} label="9878654786" />
        <Chip icon={<CastForEducationOutlinedIcon />} label="2 Smart Classes" />
        <Chip icon={<SchoolOutlinedIcon />} label="20 Teachers" />
        </Typography>
      </CardContent>

    </Card>
  );
}
